<div class="base" (click)="baseOnClick()">
  <div class="contenedor" id="contenedor">
    <div class="contenido">
      <!--
                <ul>
                    <li *ngFor="let opc of cbOpciones;index as i">
                        <div (click)="emitirRespuesta(opc)" class="combo-button">
                            {{opc}}
                        </div>
                    </li>
                </ul>
                -->
      <!-- Its important that you keep list attribute empty to hide the default dropdown icon and the browser's default datalist -->


      <div class="linea1">
        <!--
        <input _ngcontent-tbq-c6="" autocomplete="off" id="cbInput" list="" placeholder="" role="combobox"
          class="usrselecdiv usrcombo textoinput"
          style="display: block;width: 133px;height: 26px;margin-bottom: 0px;border-color: #1a8ef7;border-width: 3px;border-style: solid none solid solid;">
        -->
        <input autocomplete="off" role="combobox" list="" id="cbInput" (focus)="cbInputOnFocus()"
          (input)="cbInputOnInput()" (keydown)="cbInputOnKeydown($event)" (click)="inputOnClick()" placeholder=""
          value="{{cbPlaceholder}}">
        <div class="oktexto" id="elemOkTexto" (click)="oktextoOnClick()">&#x2713;</div>
      </div>

      <div class="combo scroll-hidex-showy" id="cbHoldData">
        <datalist id="cbDatalist">
          <option *ngFor="let opc of cbOpciones;index as i" [ngValue]="opc" (click)="emitirRespuesta(opc)"
            class="combo-button">
            {{ opc }}
          </option>
        </datalist>
      </div>
    </div>
  </div>
</div>